import React, { useEffect } from "react";
import "../PopupCommonStyle.css";
import styles from "./Style.module.css";
import { BtnClose } from "../../Buttons/BtnClose/BtnClose";
import { BtnSecondary } from "../../Buttons/BtnSecondary";

export const VoucherTermsModal = ({ active = false, onClose, termsText = "" }) => {
  useEffect(() => {
    if (active) {
      document.body.classList.add("overlay", "overflow-hidden", "overlay-index");
    } else {
      document.body.classList.remove("overlay", "overflow-hidden", "overlay-index");
    }

    return () => {
      document.body.classList.remove("overlay", "overflow-hidden", "overlay-index");
    };
  }, [active]);

  // Parse terms text - split by bullets or line breaks
  const parseTerms = (text) => {
    if (!text) return [];
    return text
      .split(/[•\n]/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);
  };

  const terms = parseTerms(termsText);

  return (
    <div className={`${styles.termsModal} popup ${active ? "show" : ""}`}>
      <div className={`${styles.popHeader} popup-header`}>
        <h2 className="title">Terms & Conditions</h2>
        {/* <BtnClose handleClick={onClose} title="Close" customClass={`${styles.closeBtn}`} /> */}
      </div>

      <div className={`${styles.termsContent} popup-body`}>
        <p className={styles.introText}>
          Please read the following terms before purchasing or redeeming this voucher.
        </p>

        {terms.length > 0 ? (
          <ul className={styles.termsList}>
            {terms.map((term, index) => (
              <li key={index} className={styles.termsItem}>
                {term}
              </li>
            ))}
          </ul>
        ) : (
          <p className={styles.noTerms}>No terms and conditions available.</p>
        )}
      </div>

      <div className={`${styles.footer} popup-footer`}>
        <BtnSecondary
          label="Close"
          handleClick={onClose}
          customClass="w-100 no-icon"
        />
        {/* <button className={styles.closeButton} onClick={onClose}>
          Close
        </button> */}
      </div>
    </div>
  );
};
